import { MeetingsPanel } from "@/components/MeetingsPanel";

export default function Meetings() {
  return (
    <div>
      <div className="mb-8">
        <div className="overline mb-2">Scheduled</div>
        <h1 className="font-dash text-3xl">Meetings &amp; Calls</h1>
        <p className="text-zinc-500 mt-2 text-sm">Your upcoming meetings, video call links, locations and agreed fees.</p>
      </div>
      <MeetingsPanel />
    </div>
  );
}
